// the types of our modals
export const EDIT_FILE_DIALOG = 'EDIT_FILE_DIALOG';
export const REMOVE_FILE_DIALOG = 'REMOVE_FILE_DIALOG';



// WEBPACK FOOTER //
// ./src/constants/modalTypes.js